export default {
  state: {
    show: true
  },
  mutations: {
    changeIndexShow(state, value) {
      state.show = value;
    }
  }
}